import { sonnerToast } from '../../../../lib/sonner';
import ToastBar, { ToastBarProps } from './ToastBar';

/** I recommend abstracting the toast function
 *  so that you can call it without having to use toast.custom everytime. */
export function toast(toast: Omit<ToastBarProps, 'id'>) {
  const {
    type,
    title,
    description,
    isTextOverflow,
    isShowActionButton,
    button,
    className,
    toastOptions,
    ...rest
  } = toast;

  return sonnerToast.custom(
    (id) => (
      <ToastBar
        id={id}
        type={type}
        title={title}
        description={description}
        isTextOverflow={isTextOverflow}
        isShowActionButton={isShowActionButton}
        button={{
          label: button?.label || '',
          onClick: button?.onClick || (() => {}),
        }}
        className={className}
        {...rest}
      />
    ),
    {
      ...toastOptions,
    },
  );
}
